export default class SystemInfo {
  constructor() {
    const unknown = '-';

    // screen
    let screenSize = '';
    let screenWidth = -1;
    let screenHeight = -1;
    if (window.screen.width) {
      const width = (window.screen.width) ? window.screen.width : -1;
      const height = (window.screen.height) ? window.screen.height : -1;
      screenSize += `${width} x ${height}`;
      screenWidth = width;
      screenHeight = height;
    }

    // browser
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    let browser = navigator.appName;
    let version = `${parseFloat(navigator.appVersion)}`;
    let majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset;
    let verOffset;
    let ix;

    function indexInAgent(keyword: string) {
      if (!nAgt) {
        return -1;
      }
      return nAgt.toLowerCase().indexOf(keyword.toLowerCase());
    }

    // Opera
    verOffset = indexInAgent('Opera');
    if (verOffset !== -1) {
      browser = 'Opera';
      version = nAgt.substring(verOffset + 6);
      verOffset = nAgt.indexOf('Version');
      if (verOffset !== -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
    // Opera Next
    verOffset = indexInAgent('OPR');
    if (verOffset !== -1) {
      browser = 'Opera';
      version = nAgt.substring(verOffset + 4);
    }
    // Edge
    verOffset = indexInAgent('Edge');
    if (verOffset !== -1) {
      browser = 'Microsoft Edge';
      version = nAgt.substring(verOffset + 5);
    }
    // Vivaldi
    verOffset = indexInAgent('Vivaldi');
    if (verOffset !== -1) {
      browser = 'Vivaldi';
      version = nAgt.substring(verOffset + 5);
    }
    // MSIE
    verOffset = indexInAgent('MSIE');
    if (verOffset !== -1) {
      browser = 'Microsoft Internet Explorer';
      version = nAgt.substring(verOffset + 5);
    }
    // Safari
    verOffset = indexInAgent('Safari');
    if (verOffset !== -1) {
      browser = 'Safari';
      version = nAgt.substring(verOffset + 7);
      verOffset = indexInAgent('Version');
      if (verOffset !== -1) {
        version = nAgt.substring(verOffset + 8);
      }
    }
    // Chrome
    verOffset = indexInAgent('Chrome');
    if (verOffset !== -1) {
      browser = 'Chrome';
      version = nAgt.substring(verOffset + 7);
    }

    verOffset = indexInAgent('Firefox');
    if (verOffset !== -1) {
    // Firefox
      browser = 'Firefox';
      version = nAgt.substring(verOffset + 8);
    } else if (indexInAgent('Trident/') !== -1) {
    // MSIE 11+
      browser = 'Microsoft Internet Explorer';
      version = nAgt.substring(indexInAgent('rv:') + 3);
    } else if (!browser) {
    // Other browsers
      nameOffset = nAgt.lastIndexOf(' ') + 1;
      verOffset = nAgt.lastIndexOf('/');
      if (nameOffset < verOffset) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }
    }

    // trim the version string
    ix = version.indexOf(';');
    if (ix !== -1) version = version.substring(0, ix);
    ix = version.indexOf(' ');
    if (ix !== -1) version = version.substring(0, ix);
    ix = version.indexOf(')');
    if (ix !== -1) version = version.substring(0, ix);

    majorVersion = parseInt(`${version}`, 10);
    if (Number.isNaN(majorVersion)) {
      version = `${parseFloat(navigator.appVersion)}`;
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    // mobile version
    const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // cookie
    let cookiesEnabled = !!(navigator.cookieEnabled);

    if (typeof navigator.cookieEnabled === 'undefined' && !cookiesEnabled) {
      document.cookie = 'testcookie';
      cookiesEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }

    // system
    let os = unknown;
    const clientStrings = [
      { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
      { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
      { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
      { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
      { s: 'Windows Vista', r: /Windows NT 6.0/ },
      { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
      { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
      { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
      { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
      { s: 'Windows 98', r: /(Windows 98|Win98)/ },
      { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
      { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
      { s: 'Windows CE', r: /Windows CE/ },
      { s: 'Windows 3.11', r: /Win16/ },
      { s: 'Android', r: /Android/ },
      { s: 'Open BSD', r: /OpenBSD/ },
      { s: 'Sun OS', r: /SunOS/ },
      { s: 'Chrome OS', r: /CrOS/ },
      { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
      { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
      { s: 'Mac OS X', r: /Mac OS X/ },
      { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
      { s: 'QNX', r: /QNX/ },
      { s: 'UNIX', r: /UNIX/ },
      { s: 'BeOS', r: /BeOS/ },
      { s: 'OS/2', r: /OS\/2/ },
      { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
    ];
    for (let i = 0; i < clientStrings.length; i += 1) {
      const cs = clientStrings[i];
      if (cs.r.test(nAgt)) {
        os = cs.s;
        break;
      }
    }

    let osVersion = unknown;

    if (/Windows/.test(os)) {
      const result = /Windows (.*)/.exec(os);
      if (result) {
        [osVersion] = result;
        os = 'Windows';
      }
    }

    switch (os) {
      case 'Mac OS X': {
        const result = /Mac OS X (10[._\d]+)/.exec(nAgt);
        if (result) {
          [osVersion] = result;
        }
        break;
      }

      case 'Android': {
        const result = /Android ([._\d]+)/.exec(nAgt);
        if (result) {
          [osVersion] = result;
        }
        break;
      }

      case 'iOS': {
        const result = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
        if (result) {
          const [tempVersion] = result;
          osVersion = `${tempVersion[1]}.${tempVersion[2]}.${tempVersion[3] || 0}`;
        }
        break;
      }
      default:
        break;
    }

    this.screen = screenSize;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.browser = browser;
    this.browserVersion = version;
    this.browserMajorVersion = majorVersion;
    this.mobile = mobile;
    this.os = os;
    this.osVersion = osVersion;
    this.cookiesEnabled = cookiesEnabled;
  }

  screenWidth: number;
  screenHeight: number;
  screen: string;
  browser: string;
  browserVersion: string;
  browserMajorVersion: number;
  mobile: boolean;
  os: string;
  osVersion: string;
  cookiesEnabled: boolean;
}
